export const createApiCall =
	(apiCall) =>
	async (args, { rejectWithValue, extra: client, getState }) => {
		try {
			return await apiCall(args, client, getState);
		} catch (error) {
			// Sprawdź, czy to błąd Axios z odpowiedzią serwera
			if (error.isAxiosError && error.response) {
				// Odrzuć z danymi odpowiedzi i statusem
				return rejectWithValue({
					data: error.response.data,
					status: error.response.status,
				});
			} else {
				// W przeciwnym razie odrzuć z całym obiektem błędu
				return rejectWithValue(error);
			}
		}
	};
